import * as actionTypes from "~/store/action_types";

const initialState = {};

const projectCategories = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ANGULAR_INIT_PROJECT_CATEGORIES:
    case actionTypes.EDIT_PROJECT_CATEGORY_SUCCESS:
    case actionTypes.ADD_PROJECT_CATEGORY_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { projectCategories } = entities;

      if (projectCategories) {
        return {
          ...state,
          ...projectCategories,
        };
      }
      return state;
    }
    case actionTypes.DELETE_PROJECT_CATEGORY_LOADING:
    case actionTypes.DELETE_PROJECT_CATEGORY_SUCCESS: {
      const { id } = action;
      if (state[id]) {
        const newState = { ...state };
        delete newState[id];
        return newState;
      }
      return state;
    }
    default:
      return state;
  }
};

export default projectCategories;
